import React from 'react'
import { useParams } from 'react-router-dom'
import {Bikes} from "../.././Bikes"
import Header from '../header/Header'
import Footer from '../footer/Footer'
import "./Bike.css"
import Price from "../Price"
import PayButton from "../payment/PayButton"

export default function Bike(){
    let {id} = useParams()
    id = parseInt(id)
    var selected_bike =  Bikes.filter(
        (bike) => {
            return bike.id === id;
        }
    )[0]
    return(
        <div className='conatiner-fluid'>
        <Header></Header>
        <div className="zoom-view">
                        <img src={`/${selected_bike.image}`}  alt="..." />
                           <div className="card-body">
                           <span className="card-title">{selected_bike.Brand}</span>
                            <Price value={selected_bike.Price} />
                            <p className="my-0 text-secondary fs-6">{selected_bike.Features}</p>
                            <p className="my=0">{selected_bike.Suitablility}</p>
                            <PayButton note={`${selected_bike.Brand} (id ${selected_bike.id})`} />
                           </div>
                </div>
        <Footer></Footer>
        </div>
    )
}